import './css/Home.css'

import CarouselHome from '../componentes/CarouselHome';

function Home() {

    const linksUteisObjList = [
        { 'id': 1, 'textoButton': 'Contrato de Gestão com a Empresa Pública Riosaúde', 'url': 'https://saude.prefeitura.rio/contrato-de-gestao-com-a-empresa-publica-riosaude/' },
        { 'id': 2, 'textoButton': 'Empresa Pública de Saúde do Rio de Janeiro', 'url': 'https://riosaude.prefeitura.rio/' },
        { 'id': 3, 'textoButton': 'Sistema Integrado Riosaúde - Prestação de Contas', 'url': 'https://www.riosaude.rio.br/sirg/html/publicos/prestacao-contas/index.php' },
        { 'id': 4, 'textoButton': 'SMS.Rio', 'url': 'https://web2.smsrio.org/subgeral/' },
        { 'id': 5, 'textoButton': 'Secretaria Municipal de Saúde', 'url': 'https://saude.prefeitura.rio/' },
        { 'id': 6, 'textoButton': 'Prefeitura.rio', 'url': 'https://prefeitura.rio/' }
    ]

    return (
        // <div className='pagina-tamanho-minimo container-fluid'>flex-fill
        <div className='container-fluid'>
            <div className='container p-3'>
                <CarouselHome />
            </div>
            <div className='container titulo-servicos-home'>
                <p className='mb-3 h1 fw-bold'>SERVIÇOS</p>
            </div>
            <div className="container w-75">
                <div className="row">
                    {linksUteisObjList.map((link) => (
                        <div
                            key={link.id}
                            className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                        >
                            <button
                                className="home-botoes-links-uteis"
                                onClick={() => window.open(link.url, '_blank')}
                            >
                                {link.textoButton}
                            </button>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}

export default Home
